import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M23.805,11.525l-3.871-3.872c-0.327-2.749-2.585-4.828-5.435-4.828c-1.74,0-3.41,0.811-4.5,2.09 C8.909,3.636,7.24,2.825,5.5,2.825c-3.08,0-5.5,2.42-5.5,5.5c0,3.78,3.399,6.859,8.55,11.531l1.449,1.318l1.451-1.309 c1.831-1.664,3.418-3.119,4.73-4.481v3.091c0,0.272,0.163,0.519,0.415,0.622c0.084,0.034,0.171,0.051,0.258,0.051 c0.174,0,0.347-0.069,0.475-0.197l6.477-6.476C24.066,12.213,24.066,11.788,23.805,11.525z M5.728,15.286v-4.273H3.351l3.412-6.648 v4.272H9.05L5.728,15.286z M17.525,16.853v-2.267c0-0.371-0.301-0.672-0.672-0.672h-4.507v-3.828h4.507 c0.371,0,0.672-0.302,0.672-0.672V7.147L22.378,12L17.525,16.853z"/>',
    }
  },
}